
import { addMetaTags } from '@/utility'

export default {
  name: 'DefaultLayout',

  watch: {
    $route() {
      window.vgo('update')
    },
  },

  mounted() {
    if (process.browser) {
      this.$gtag('event', 'conversion', {
        send_to: 'AW-1016253253/LPagCJDSoYgBEMWWy-QD',
      })
    }
  },

  methods: {
    onOverlayClick(e) {
      document.body.classList.remove('menuopen')
    },
  },

  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: this.$config.baseUrl + this.$route.path,
        },
      ],
      meta: addMetaTags({
        image:
          this.$config.baseUrl +
          require('@/assets/img/homebg_test2.jpg?sizes[]=1200'),
      }),
    }
  },
}
